export default __webpack_public_path__ + "static/media/masai_refresh4.ad664597.png";